import {USER_KEYS} from "@/api/userApi";
import FullPageLoader from "@/components/Common/FullPageLoader";
import {client} from "@/httpClient";
import {isConfirmEmailModalOpenAtom} from "@/store/jotaiAtoms";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {createFileRoute, useRouter} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {useSetAtom} from "jotai";
import {useTranslation} from "react-i18next";
import {useEffectOnce, useTitle} from "react-use";
import {z} from "zod";

export const Route = createFileRoute("/verify-account")({
  component: VerifyAccount,
  validateSearch: zodValidator(
    z.object({
      token: z.string().optional(),
      user: z.number().optional(),
    }),
  ),
});

function VerifyAccount() {
  const {t} = useTranslation(["common", "verify_account"]);

  useTitle(t("verify_account:email_verification"));

  const navigate = Route.useNavigate();
  const router = useRouter();
  const {user: userId} = Route.useSearch();
  const queryClient = useQueryClient();
  const setIsConfirmEmailModalOpen = useSetAtom(isConfirmEmailModalOpenAtom);

  const {mutate, status} = useMutation({
    meta: {skipSuccessToast: true},
    mutationKey: USER_KEYS.mUserAccountVerification(router.state.location.searchStr),
    mutationFn: () => client.post(USER_KEYS.mUserAccountVerification(router.state.location.searchStr)[0]),
    onSuccess: async () => {
      setIsConfirmEmailModalOpen(false);

      try {
        if (userId) {
          const userData = await client.get(USER_KEYS.qUser(userId)[0]);
          queryClient.setQueryData(USER_KEYS.qUser(userId), userData);
        }
      } finally {
        navigate({to: "/welcome"});
      }
    },
  });

  useEffectOnce(() => {
    mutate();
  });

  if (status === "pending") {
    return <FullPageLoader />;
  }

  return (
    <div className="text-neutral-black max-w-wide mx-auto flex h-[95vh] flex-col items-center justify-center gap-6 px-10">
      <span className="w-full text-center text-4xl font-medium">
        {status !== "success" && t("Account could not be verified")}
      </span>
    </div>
  );
}
